import React, { createContext, useContext } from 'react'
import { GroupRowData, TypedEditableCallbackParams } from '.'

export const DataGridContext = createContext<{ groupRowData: GroupRowData<unknown> | undefined } | undefined>({
  groupRowData: undefined
})

// use this to wrap cell editors and augment the aggrid context object and rerender when context changes
// ag-grid will not re-render cell editors when api.refreshCells() is invoked and so props
// including context can be stale.
export const augmentAgGridContextWithDataGridContext = <T, S, P extends TypedEditableCallbackParams<T, S>>(
  Component: React.ComponentType<P>
): React.ComponentType<P> =>
  React.forwardRef((props, ref) => {
    const dataGridContext = useContext(DataGridContext)
    return <Component {...{ ...props, context: { ...props.context, ...dataGridContext } }} ref={ref} />
  }) as React.ComponentType<P>
